import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class PanelDetailRouteService {

  private title: string;
  private id: string;
  private keys: string[] = [];
  private values: string[] = [];
  private id$: Subject<string> = new Subject<string>();
  private keys$: Subject<string[]> = new Subject<string[]>();
  private values$: Subject<string[]> = new Subject<string[]>();
  private lastUpdate$: Subject<string> = new Subject<string>();

  public isVisible = false;
  constructor() { }

  checkVisibilityPopup(): Observable<boolean> {
    return this.isVisiblePopup$.asObservable();
  }
  private isVisiblePopup$ = new Subject<boolean>();

  getVisibilityPopup(): Observable<boolean> {
    return this.isVisiblePopup$.asObservable();
  }

  setVisibilityPopup(op) {
    this.isVisible = op;
    this.isVisiblePopup$.next(op);
  }

 
}